<template lang="pug">
    v-container( fluid fill-height class="tw-pb-0 tw-px-0"  )
        v-row(no-gutters align="self-stretch"  )
            v-col( class="tw-relative")
                div(class="tw-px-4")
                    v-row(no-gutters)
                        v-col
                            span(class="text-secondary tw-font-bold tw-text-lg") New Office
                    v-row( no-gutters align="center" class=" tw-mt-4 ")
                        v-col(cols="auto")
                            v-img(:src="sampleWebsiteImage('houseExterior', 200, 200)" contain class="tw-rounded tw-border tw-border-blueGray-darken-1" width="80px"  )
                        v-col
                            v-row(no-gutters)
                                v-col
                                    v-file-input( v-model="officeLogo" label="Office logo" dense)
                    v-row(no-gutters)
                        v-col
                            v-text-field( label="Name")
                    v-row(no-gutters) 
                        v-col
                            v-text-field(label="Street Address")
                    v-row(no-gutters)
                        v-col(class="pr-2")
                            v-text-field(label="City")
                        v-col(class="pl-2")
                            v-text-field(label="Zip Code")
                    v-row(no-gutters)
                        v-col(class="pr-2")
                            v-text-field(label="State")
                        v-col(class="pl-2")
                            v-text-field(label="Country")
                    v-row(no-gutters class="tw-pb-12")
                        v-col
                            v-text-field(label="Phone")
                            
                v-row(no-gutters align="center" justify="end" class=" tw-mt-6 tw-px-4  tw-bg-indigo-lighten-4 tw-bg-opacity-25 tw-self-end tw-absolute tw-w-full  tw-bottom-0 ")
                    v-col(cols="auto")
                        v-btn( x-small text elevation="0" :ripple="false" @click="$emit('close')" )
                            span( class=" tw-text-xs tw-pt-4 tw-text-gray-darken-1") CANCEL
                    v-col(cols="auto" )
                        v-btn( depressed color="rgba(94,129,244,0.80)"  ) 
                            span(class="tw-font-bold" ) ADD

                            
                            
                        

</template>

<script>
    export default {
        data() {
            return {
                notes: [],
            }
        },
        mounted() {
            for (let index = 0; index < 40; index++) {
                let note = {}
                note.text = this.$faker().lorem.lines(2)
                note.date = this.$moment(this.$faker().date.recent(3)).fromNow()
                this.notes.push(note)
            }
        }
    }
</script>
